import PropTypes from 'prop-types';

import EmptyTransaction from './EmptyTransaction';
import { ListTransaction } from './ListTransaction';

const Transactions = ({ transactions, maxTransaction = 2 }) => {
  if (!transactions.length) {
    return <EmptyTransaction />;
  }

  return (
    <ListTransaction
      maxTransaction={maxTransaction}
      transactions={transactions}
    />
  );
};

Transactions.propTypes = {
  transactions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      direction: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      summary: PropTypes.string.isRequired,
      amount: PropTypes.shape({
        formattedAmount: PropTypes.string.isRequired
      }),
      checkDepositId: PropTypes.string
    })
  ).isRequired,
  maxTransaction: PropTypes.number
};

export default Transactions;
